import React, { useState } from 'react';
import { Button } from '@/components/button';
import { useCookieConsent } from '@/hooks/useCookieConsent';
import { useLocalization } from '@/localization';
import { BannerActions, BannerBody, BannerContainer, BannerContent, BannerHeading, } from './cookie-consent-banner.styles';
import { CookieConsentModal } from './CookieConsentModal';
function CookieConsentBanner() {
    const { consentGiven, initialCategories, accept, decline, save, } = useCookieConsent();
    const { formatMessage: t } = useLocalization();
    const [isModalOpen, setIsModalOpen] = useState(false);
    if (consentGiven !== null) {
        return null;
    }
    return (<React.Fragment>
      <BannerContainer data-testid="cookie-consent-banner">
        <BannerContent>
          <BannerHeading>
            {t({ key: 'COOKIE_CONSENT_BANNER_HEADING' })}
          </BannerHeading>
          <BannerBody>
            {t({ key: 'COOKIE_CONSENT_BANNER_BODY' })}
          </BannerBody>
        </BannerContent>

        <BannerActions>
          <Button rounded variant="contained" color="primary" data-testid="cookie-consent-accept-btn" onClick={accept}>
            {t({ key: 'COOKIE_CONSENT_ACCEPT_ALL' })}
          </Button>

          <Button rounded data-testid="cookie-consent-decline-btn" onClick={decline}>
            {t({ key: 'COOKIE_CONSENT_DECLINE_ALL' })}
          </Button>

          <Button rounded data-testid="cookie-consent-manage-btn" onClick={() => setIsModalOpen(true)}>
            {t({ key: 'COOKIE_CONSENT_MANAGE_PREFERENCES' })}
          </Button>
        </BannerActions>
      </BannerContainer>

      {isModalOpen && (<CookieConsentModal onSave={save} onClose={() => setIsModalOpen(false)} initialCategories={initialCategories}/>)}
    </React.Fragment>);
}
export { CookieConsentBanner };
